import { getSourceJobId as searchSourceJobId } from '../../search/store/selectors'

import defaultState from './defaultState'

const unwrapState = (state) => state.similarJobs || defaultState

/**
 * Returns the source job id if any.
 *
 * Note: used for tracking
 *
 * @param {object} state - the redux state
 * @returns {number|null} - id of the source job or null if none
 */
export const getSourceJobId = (state) => searchSourceJobId(state) || unwrapState(state).sourceJobId

/**
 * Returns the selected job id
 *
 * Note: Similar jobs are available only on JOB_DETAIL pages.
 *
 * @param state - the redux state
 * @returns {number|null} - id of the selected job or null if none
 */
export const getSelectedJobId = (state) => unwrapState(state).selectedJobId

export const getSimilarJobsParams = (state) => unwrapState(state).params

export const getSimilarJobsLoading = (state) => unwrapState(state).jobsResults.loading

export const getSimilarJobsList = (state) => unwrapState(state).jobsResults.items

export const getSimilarJobsCount = (state) => unwrapState(state).jobsResults.totalCount

export const getSimilarJobsOffset = (state) => unwrapState(state).jobsResults.items.length
